import { PdfQuestionnaireBoundary } from "./PdfQuestionnaireBoundary";
import { PdfQuestionnaireForm } from "./PdfQuestionnaireForm";

export const PdfQuestionnaireEmpty = () => <PdfQuestionnaireBoundary>{() => <PdfQuestionnaireForm />}</PdfQuestionnaireBoundary>;
